/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MCQOptionCreateFeedback } from './mCQOptionCreateFeedback';
import type { MCQOptionCreateImageUrl } from './mCQOptionCreateImageUrl';
import type { MCQOptionCreateImageAlt } from './mCQOptionCreateImageAlt';

/**
 * Request to create an MCQ option (without server-generated fields).
 */
export interface MCQOptionCreate {
  text: string;
  isCorrect: boolean;
  feedback?: MCQOptionCreateFeedback;
  imageUrl?: MCQOptionCreateImageUrl;
  imageAlt?: MCQOptionCreateImageAlt;
}
